import React from "react";
import { SelectComp2, TextInputComp } from "..";
import { LATE_FEE_TYPE_OPTIONS } from "./lateFee";

/** Late fee settings block for the loan type forms (inside a Formik form). */
const LateFeeFields = ({ values, setFieldValue }) => {
  const on = !!values.late_fee_type;
  const percent = values.late_fee_type === "PERCENT";

  return (
    <>
      <div className="col-12 mb-1 mt-2">
        <h6 className="fw-bold mb-1 text-black1">Late fee</h6>
        <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
          Charged once for each missed due date, on everything overdue at that moment. Late fees are
          never charged on earlier late fees, and payments clear them before the installments.
        </p>
      </div>

      <div className="col-12 col-lg-6">
        <SelectComp2
          LabelClassName={"fw-bold text-black1 mb-1"}
          labelText={"Late fee (optional)"}
          placeholder={"No late fee"}
          arrayComp={LATE_FEE_TYPE_OPTIONS}
          selectedOption={
            LATE_FEE_TYPE_OPTIONS.find((opt) => opt.value === values.late_fee_type) ??
            LATE_FEE_TYPE_OPTIONS[0]
          }
          setSelectedOption={(selected) => setFieldValue("late_fee_type", selected?.value ?? "")}
        />
      </div>

      {on && (
        <>
          <div className="col-12 col-lg-6">
            <TextInputComp
              LabelText={percent ? "Fee (%)" : "Fee (₦)"}
              LabelClassName={"fw-bold text-black1 mb-1"}
              placeholder={percent ? "e.g. 5" : "e.g. 2000"}
              name="late_fee_value"
              type="number"
              desc={
                percent
                  ? "Taken from the overdue amount each time a due date is missed"
                  : "Added each time a due date is missed"
              }
            />
          </div>
          <div className="col-12 col-lg-6">
            <TextInputComp
              LabelText={"Grace period in days (optional)"}
              LabelClassName={"fw-bold text-black1 mb-1"}
              placeholder={"0"}
              name="late_fee_grace_days"
              type="number"
              desc="Days after the due date before a fee is charged"
            />
          </div>
          <div className="col-12 col-lg-6">
            <TextInputComp
              LabelText={"Maximum total fees per loan (optional)"}
              LabelClassName={"fw-bold text-black1 mb-1"}
              placeholder={"No limit"}
              name="late_fee_cap"
              type="number"
              desc="Stops charging once a loan has reached this much in late fees"
            />
          </div>
        </>
      )}
    </>
  );
};

export default LateFeeFields;
